import Swiper from "../../node_modules/swiper/swiper-bundle.esm.browser";

export function init() {

	var swipers = {};

	swipers.brands = new Swiper('.swiper__brands', {
		// slidesPerView: 5,
		// slidesPerGroup: 5,
		autoplay: {
			delay: 3000
		},
		loop: true,

		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 2,
			},
			// when window width is >= 480px
			640: {
				slidesPerView: 3,
			},
			// when window width is >= 640px
			1200: {
				slidesPerView: 5
			}
		},

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});

	swipers.countries = new Swiper('.swiper__countries', {
		// slidesPerView: 5,
		// slidesPerGroup: 5,
		// autoplay: {
		// 	delay: 4000,
		// },
		loop: true,
		centeredSlides: true,

		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 2,
			},
			// when window width is >= 480px
			640: {
				slidesPerView: 3,
			},
			// when window width is >= 640px
			1200: {
				slidesPerView: 5
			}
		},

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});



	swipers.hero = new Swiper('.swiper__hero', {
		autoplay: true,
		loop: true,
		// spaceBetween: 30,
		effect: 'fade',
	});

	let active_class = "is_active";
	const bottleshot_transition_start = function () {
		let $active = $("." + active_class);
		$active.removeClass(active_class).fadeOut(300);
	};
	const bottleshot_transition_end = function () {
		let id = $(".swiper-slide-active img").attr("id");
		let target = ".bottleshots__content--" + id;
		let $target = $(target);
		$target.addClass(active_class).fadeIn(300);
	};

	swipers.brand = new Swiper('.swiper__brand', {
		loop: false,
		slidesPerView: 3,
		centeredSlides: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		on: {
			init: bottleshot_transition_end,
			slideChangeTransitionStart: bottleshot_transition_start,
			slideChangeTransitionEnd: bottleshot_transition_end
		},
	});

}
